import { Spinner } from "react-bootstrap";
import styles from "./Button.module.scss";

type ButtonProps = {
    id?: string;
    label?: string;
    onClick?: () => void;
    type?: "button" | "submit" | "reset";
    loading?: boolean;
    disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
    id,
    label,
    onClick,
    type = "button",
    loading = false,
    disabled = false, 
}) => {
    return (
        <button
            id={id}
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`${styles.button} mt-4`}
        >
            {loading && (
                <Spinner as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="mb-1 align-items-center justify-content-center"
                />
            )}
            {loading ? "" : label}
        </button>
    );
};

export default Button;
